(function () {
  "use strict";

  const root = document.getElementById("giant-d20-runner");
  if (!root) return;
  document.documentElement.classList.add("gauntlet-runner-page");
  document.body.classList.add("gauntlet-runner-page");

  const CLASS_DATA = {
    F: { name: "Fighter", ac: 14, hp: 4, css: "fighter", icon: "shield" },
    W: { name: "Wizard", ac: 10, hp: 3, css: "wizard", icon: "wand-sparkles" },
    S: { name: "Spellblade", ac: 12, hp: 3, css: "spellblade", icon: "swords" }
  };
  const POSITIONS = [
    { x: 50, y: 6, rx: 50, ry: 25 },
    { x: 81, y: 18, rx: 71, ry: 31 },
    { x: 94, y: 50, rx: 75, ry: 50 },
    { x: 81, y: 82, rx: 71, ry: 69 },
    { x: 50, y: 94, rx: 50, ry: 75 },
    { x: 19, y: 82, rx: 29, ry: 69 },
    { x: 6, y: 50, rx: 25, ry: 50 },
    { x: 19, y: 18, rx: 29, ry: 31 }
  ];
  const SEAT_SLOTS = {
    2: [0, 4],
    3: [0, 3, 6],
    4: [0, 2, 4, 6],
    5: [0, 2, 3, 5, 6],
    6: [0, 1, 3, 4, 5, 7],
    7: [0, 1, 2, 3, 5, 6, 7],
    8: [0, 1, 2, 3, 4, 5, 6, 7]
  };
  const STORAGE_KEY = "fivefold-gauntlet-arena-chronicle-v1";
  const CLASS_COLORS = {
    F: "var(--viz-series-1)",
    W: "var(--viz-series-2)",
    S: "var(--viz-series-3)"
  };

  function repairTextEncoding(value) {
    return String(value)
      .replace(/\u00C2\u00B7/g, "\u00B7")
      .replace(/\u00C2\u00A9/g, "\u00A9")
      .replace(/\u00E2\u02DC\u2026/g, "\u2605")
      .replace(/\u00E2\u0098\u0085/g, "\u2605")
      .replace(/\u00E2\u02DC\u2020/g, "\u2606")
      .replace(/\u00E2\u0098\u0086/g, "\u2606")
      .replace(/\u00E2\u2020\u2019/g, "\u2192")
      .replace(/\u00E2\u0086\u0092/g, "\u2192")
      .replace(/\u00E2\u20AC\u201C/g, "\u2013")
      .replace(/\u00E2\u0080\u0093/g, "\u2013")
      .replace(/\u00E2\u02C6\u2019/g, "\u2212")
      .replace(/\u00E2\u0088\u0092/g, "\u2212")
      .replace(/\u00E2\u20AC\u00BA/g, "\u203A")
      .replace(/\u00E2\u0080\u00BA/g, "\u203A");
  }

  function normalizeLogTerminology(entry) {
    if (typeof entry === "string") {
      return repairTextEncoding(entry).replace("Simulation paused after 100 attack steps.", "Simulation paused after 100 rounds.");
    }
    if (!entry || typeof entry !== "object") return entry;
    const normalized = Object.assign({}, entry);
    Object.keys(normalized).forEach((key) => {
      if (typeof normalized[key] === "string") {
        normalized[key] = repairTextEncoding(normalized[key]);
      } else if (Array.isArray(normalized[key])) {
        normalized[key] = normalized[key].map((item) => typeof item === "string" ? repairTextEncoding(item) : item);
      }
    });
    if (typeof normalized.title === "string") {
      normalized.title = normalized.title
        .replace(/^M(\d+)\s*\u00B7\s*Step\s+(\d+)$/i, "E$1 \u00B7 Round $2")
        .replace(/^Match\s+(\d+)\s*\u00B7\s*Step\s+(\d+)$/i, "Encounter $1 \u00B7 Round $2");
    }
    return normalized;
  }

  function normalizeReplayLogs(replayState) {
    if (replayState && Array.isArray(replayState.logs)) {
      replayState.logs = replayState.logs.map(normalizeLogTerminology);
    }
    return replayState;
  }

  function loadChronicle() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      if (!Array.isArray(saved)) return [];
      saved.forEach((gauntlet) => {
        (gauntlet.encounters || []).forEach((encounter) => {
          (encounter.rounds || []).forEach((round) => {
            round.log = normalizeLogTerminology(round.log);
            normalizeReplayLogs(round.startState);
            normalizeReplayLogs(round.endState);
          });
        });
      });
      return saved;
    } catch (error) {
      return [];
    }
  }

  let state = {
    phase: "setup",
    playerCount: 4,
    encounterCount: 5,
    encounter: 1,
    step: 1,
    players: [],
    logs: [],
    encounterHistory: [],
    snapshots: [],
    championshipWinner: null,
    pendingResolution: null,
    visualSelector: null,
    gauntletId: null,
    branchLabel: null,
    roundStart: null,
    validationAttempted: false,
    chronicle: loadChronicle()
  };

  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => Array.from(root.querySelectorAll(selector));
  const esc = (value) => String(value).replace(/[&<>'"]/g, function (char) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", "\"": "&quot;" }[char];
  });
  const rollD20 = () => Math.floor(Math.random() * 20) + 1;
  const rollOptions = (selected) => {
    let options = '<option value="">d20</option>';
    for (let value = 1; value <= 20; value += 1) {
      options += '<option value="' + value + '"' + (Number(selected) === value ? " selected" : "") + ">" + value + "</option>";
    }
    return options;
  };
  const living = () => state.players.filter((p) => p.hp > 0);
  const spirits = () => state.players.filter((p) => p.hp <= 0);
  const playerById = (id) => state.players.find((p) => p.id === Number(id));
  const seatPosition = (id) => POSITIONS[SEAT_SLOTS[state.playerCount][Number(id) - 1]];
  const clone = (value) => JSON.parse(JSON.stringify(value));
  const uid = () => Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
  function persistChronicle() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state.chronicle)); } catch (error) { /* Storage may be unavailable in private browsing. */ }
  }
  function activeGauntlet() {
    return state.chronicle.find((item) => item.id === state.gauntletId);
  }
  function stateForReplay() {
    return {
      phase: "play",
      playerCount: state.playerCount,
      encounterCount: state.encounterCount,
      encounter: state.encounter,
      step: state.step,
      players: clone(state.players),
      logs: clone(state.logs),
      encounterHistory: clone(state.encounterHistory),
      snapshots: [],
      championshipWinner: state.championshipWinner,
      pendingResolution: null,
      visualSelector: null,
      validationAttempted: false
    };
  }
  function beginRoundRecord() {
    state.roundStart = stateForReplay();
  }
  function ensureGauntletRecord(names) {
    const record = {
      id: state.gauntletId,
      startedAt: new Date().toISOString(),
      status: "In progress",
      branchLabel: state.branchLabel,
      players: names,
      encounterCount: state.encounterCount,
      encounters: []
    };
    state.chronicle.unshift(record);
    persistChronicle();
  }
  function recordRound(logEntry) {
    const gauntlet = activeGauntlet();
    if (!gauntlet || !state.roundStart) return;
    let encounter = gauntlet.encounters.find((item) => item.number === state.encounter);
    if (!encounter) {
      encounter = { number: state.encounter, status: "In progress", rounds: [] };
      gauntlet.encounters.push(encounter);
    }
    encounter.rounds.push({
      number: state.roundStart.step,
      recordedAt: new Date().toISOString(),
      startState: clone(state.roundStart),
      endState: stateForReplay(),
      log: clone(logEntry)
    });
    state.roundStart = null;
    persistChronicle();
  }
  const ICON_PATHS = {
    F: '<path d="M20 13c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V5l8-3 8 3z"></path>',
    W: '<path d="m15 4 5 5L7 22l-5-5Z"></path><path d="m14 5 5 5"></path><path d="M6 3v4M4 5h4M19 16v4M17 18h4"></path>',
    S: '<path d="m14.5 17.5-5-5M4 19l2-2M3 22l3-3M14 5l5 5"></path><path d="m16 3 5 5-9 9H7v-5Z"></path><path d="m8 8-5 5 8 8 5-5"></path>',
    spirit: '<path d="M9 10h.01M15 10h.01"></path><path d="M12 2a8 8 0 0 0-8 8v12l3-3 2 2 3-3 3 3 2-2 3 3V10a8 8 0 0 0-8-8Z"></path>'
  };
  const iconMarkup = (kind) => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">' + ICON_PATHS[kind] + '</svg>';
  const classIdentity = (player, includeName) => {
    const isSpirit = player.hp <= 0;
    const css = isSpirit ? "spirit" : CLASS_DATA[player.cls].css;
    const name = isSpirit ? "Arena Spirit" : CLASS_DATA[player.cls].name;
    return '<span class="class-icon ' + css + '">' + iconMarkup(isSpirit ? "spirit" : player.cls) + '</span>' + (includeName ? '<span>' + name + '</span>' : "");
  };
  function refreshIcons() {}

  function classOptions(selected) {
    return Object.keys(CLASS_DATA).map((key) => {
      const item = CLASS_DATA[key];
      return '<option value="' + key + '"' + (key === selected ? " selected" : "") + ">" + item.name + "</option>";
    }).join("");
  }

  function setupRows() {
    const count = Number($("#player-count").value);
    const existing = {};
    $$("#setup-players tr").forEach((row) => {
      const id = Number(row.dataset.id);
      existing[id] = {
        name: row.querySelector("input").value,
        cls: row.querySelector("select").value
      };
    });
    $("#setup-players").innerHTML = Array.from({ length: count }, (_, i) => {
      const id = i + 1;
      const old = existing[id] || { name: "Player " + id, cls: ["F", "W", "S"][i % 3] };
      return '<tr data-id="' + id + '"><td>Position ' + id + '</td><td><label class="sr-only" for="setup-name-' + id + '">Player ' + id + ' name</label><input id="setup-name-' + id + '" class="form-control" value="' + esc(old.name) + '" maxlength="28"></td><td><label class="sr-only" for="setup-class-' + id + '">Player ' + id + ' class</label><select id="setup-class-' + id + '" class="form-select">' + classOptions(old.cls) + '</select></td></tr>';
    }).join("");
  }

  function beginSeries() {
    const rows = $$("#setup-players tr");
    const names = rows.map((row) => row.querySelector("input").value.trim());
    if (names.some((name) => !name)) return;
    const encounterCount = Number($("#encounter-count").value);
    if (!Number.isInteger(encounterCount) || encounterCount < 1 || encounterCount > 7) return;
    const chronicle = state.chronicle || loadChronicle();
    const gauntletId = uid();
    state = {
      phase: "play",
      playerCount: rows.length,
      encounterCount: encounterCount,
      encounter: 1,
      step: 1,
      players: rows.map((row, index) => {
        const cls = row.querySelector("select").value;
        return {
          id: index + 1,
          name: names[index],
          cls: cls,
          hp: CLASS_DATA[cls].hp,
          target: null,
          roll: null,
          spiritTarget: null,
          blessing: "might",
          points: 0,
          encounterPoints: 0,
          slays: 0,
          encounterSlays: 0,
          survivals: 0,
          bloodlustActive: 0,
          classHistory: [cls]
        };
      }),
      logs: ["Encounter 1 begins."],
      encounterHistory: [],
      snapshots: [],
      championshipWinner: null,
      pendingResolution: null,
      visualSelector: null,
      gauntletId: gauntletId,
      branchLabel: null,
      roundStart: null,
      validationAttempted: false,
      chronicle: chronicle
    };
    ensureGauntletRecord(names);
    $("#setup-view").classList.add("hidden");
    $("#game-view").classList.remove("hidden");
    render();
  }

  function snapshot() {
    state.snapshots.push(JSON.stringify({
      phase: state.phase,
      encounterCount: state.encounterCount,
      encounter: state.encounter,
      step: state.step,
      players: state.players,
      logs: state.logs,
      encounterHistory: state.encounterHistory,
      championshipWinner: state.championshipWinner,
      pendingResolution: state.pendingResolution,
      visualSelector: state.visualSelector,
      validationAttempted: state.validationAttempted
    }));
    if (state.snapshots.length > 20) state.snapshots.shift();
  }

  function undo() {
    const saved = state.snapshots.pop();
    if (!saved) return;
    const parsed = JSON.parse(saved);
    state.phase = parsed.phase;
    state.encounterCount = parsed.encounterCount || 5;
    state.encounter = parsed.encounter;
    state.step = parsed.step;
    state.players = parsed.players;
    state.logs = parsed.logs;
    state.encounterHistory = parsed.encounterHistory;
    state.championshipWinner = parsed.championshipWinner;
    state.pendingResolution = parsed.pendingResolution || null;
    state.visualSelector = parsed.visualSelector || null;
    state.validationAttempted = Boolean(parsed.validationAttempted);
    render();
  }

  function getBonuses() {
    const attack = {};
    const ac = {};
    spirits().forEach((spirit) => {
      if (!spirit.spiritTarget) return;
      const bucket = spirit.blessing === "protection" ? ac : attack;
      bucket[spirit.spiritTarget] = (bucket[spirit.spiritTarget] || 0) + 1;
    });
    return { attack: attack, ac: ac };
  }

  function randomTargetsAndBlessings() {
    const active = living();
    active.forEach((player) => {
      const choices = active.filter((other) => other.id !== player.id);
      player.target = choices[Math.floor(Math.random() * choices.length)].id;
    });
    spirits().forEach((spirit) => {
      spirit.spiritTarget = active[Math.floor(Math.random() * active.length)].id;
      spirit.blessing = Math.random() < 0.5 ? "might" : "protection";
    });
  }

  function threatScore(player) {
    const classThreat = player.cls === "W" ? 5 : (player.cls === "S" ? 2 : 0);
    const overHealth = Math.max(0, player.hp - CLASS_DATA[player.cls].hp);
    return player.points * 8 + player.encounterPoints * 4 + player.encounterSlays * 3 + classThreat + overHealth;
  }

  function bestStrategicTargets() {
    const active = living();
    active.forEach((attacker) => {
      const choices = active.filter((other) => other.id !== attacker.id).sort((a, b) => {
        const aValue = threatScore(a) + (21 - CLASS_DATA[a.cls].ac) * 0.12;
        const bValue = threatScore(b) + (21 - CLASS_DATA[b.cls].ac) * 0.12;
        return bValue - aValue || b.points - a.points || a.id - b.id;
      });
      attacker.target = choices[0] ? choices[0].id : null;
    });
    spirits().forEach((spirit) => {
      const threats = active.slice().sort((a, b) => threatScore(b) - threatScore(a) || a.id - b.id);
      const greatestThreat = threats[0];
      const avengers = active.filter((player) => greatestThreat && player.id !== greatestThreat.id && player.target === greatestThreat.id);
      const recipient = avengers.sort((a, b) => CLASS_DATA[b.cls].ac - CLASS_DATA[a.cls].ac || a.id - b.id)[0] || threats[threats.length - 1];
      spirit.spiritTarget = recipient ? recipient.id : null;
      spirit.blessing = "might";
    });
  }

  function rollAll() {
    living().forEach((player) => { player.roll = rollD20(); });
    render();
  }

  function validateStep() {
    const active = living();
    if (active.length <= 1) return "The Encounter is already complete.";
    for (const player of active) {
      if (!player.target || !playerById(player.target) || playerById(player.target).hp <= 0 || player.target === player.id) {
        return "Choose a living target for every active player.";
      }
      if (!Number.isInteger(player.roll) || player.roll < 1 || player.roll > 20) {
        return "Enter or roll a d20 result from 1 to 20 for every active player.";
      }
    }
    for (const spirit of spirits()) {
      if (!spirit.spiritTarget || !playerById(spirit.spiritTarget) || playerById(spirit.spiritTarget).hp <= 0) {
        return "Choose a living recipient for every Arena Spirit blessing.";
      }
    }
    return "";
  }

  function validationWarning() {
    if (state.phase !== "play" || !state.validationAttempted) return "";
    const missingTargets = [];
    const missingRolls = [];
    const missingBlessings = [];
    living().forEach((player) => {
      if (!player.target || !playerById(player.target) || playerById(player.target).hp <= 0 || player.target === player.id) missingTargets.push(player.id);
      if (!Number.isInteger(player.roll) || player.roll < 1 || player.roll > 20) missingRolls.push(player.id);
    });
    spirits().forEach((spirit) => {
      if (!spirit.spiritTarget || !playerById(spirit.spiritTarget) || playerById(spirit.spiritTarget).hp <= 0) missingBlessings.push(spirit.id);
    });
    function compactIds(ids) {
      if (!ids.length) return "";
      const sorted = ids.slice().sort((a, b) => a - b);
      const ranges = [];
      let start = sorted[0];
      let end = sorted[0];
      for (let index = 1; index <= sorted.length; index += 1) {
        const value = sorted[index];
        if (value === end + 1) {
          end = value;
        } else {
          ranges.push(start === end ? "P" + start : "P" + start + "\u2013P" + end);
          start = value;
          end = value;
        }
      }
      return ranges.join(", ");
    }
    const issues = [];
    if (missingTargets.length) issues.push("targets " + compactIds(missingTargets));
    if (missingRolls.length) issues.push("rolls " + compactIds(missingRolls));
    if (missingBlessings.length) issues.push("Spirit targets " + compactIds(missingBlessings));
    return issues.length ? "Missing: " + issues.join("; ") + "." : "";
  }

  function updateValidationWarnings() {
    const warning = validationWarning();
    const arenaWarning = $("#arena-validation-message");
    const controlsWarning = $("#resolve-validation-message");
    arenaWarning.textContent = warning;
    controlsWarning.textContent = warning;
    arenaWarning.classList.toggle("hidden", !warning);
    controlsWarning.classList.toggle("hidden", !warning);
  }

  function canonicalCycle(cycle) {
    const rotations = cycle.map((_, index) => cycle.slice(index).concat(cycle.slice(0, index)));
    rotations.sort((a, b) => a.join("-").localeCompare(b.join("-")));
    return rotations[0];
  }

  function findCycles(nodes, lethalEdges) {
    const adjacency = {};
    nodes.forEach((id) => { adjacency[id] = []; });
    lethalEdges.forEach((edge) => {
      if (adjacency[edge.from]) adjacency[edge.from].push(edge.to);
    });
    const seen = new Map();
    nodes.forEach((start) => {
      function walk(path) {
        const current = path[path.length - 1];
        (adjacency[current] || []).forEach((next) => {
          if (next === start && path.length >= 2) {
            const cycle = canonicalCycle(path.slice());
            seen.set(cycle.join("-"), cycle);
          } else if (!path.includes(next) && path.length < nodes.length) {
            walk(path.concat(next));
          }
        });
      }
      walk([start]);
    });
    return Array.from(seen.values());
  }

  function selectFinalEncounterRollOffCycles(context) {
    if (state.encounter !== state.encounterCount || living().length !== 0) return [];
    const slain = new Set(context.slainBeforeRecovery);
    const directTargetHits = context.attempts.filter((attempt) => {
      return attempt.hit &&
        context.targetIds[attempt.from] === attempt.to &&
        slain.has(attempt.from) &&
        slain.has(attempt.to) &&
        playerById(attempt.from).hp <= 0 &&
        playerById(attempt.to).hp <= 0;
    }).map((attempt) => ({ from: attempt.from, to: attempt.to }));
    return findCycles(context.activeAtStart, directTargetHits);
  }

  function runAutomaticRollOff(cycle) {
    let contenders = cycle.slice();
    const rounds = [];
    while (contenders.length > 1) {
      const results = contenders.map((id) => ({ id: id, roll: rollD20() }));
      rounds.push(results);
      const high = Math.max.apply(null, results.map((item) => item.roll));
      contenders = results.filter((item) => item.roll === high).map((item) => item.id);
    }
    return { cycle: cycle, winner: contenders[0], rounds: rounds };
  }

  function attemptText(attempt) {
    const attacker = playerById(attempt.from);
    const victim = playerById(attempt.to);
    const rolled = attempt.adjusted === attempt.raw ? attempt.raw : attempt.raw + "+" + (attempt.adjusted - attempt.raw);
    return attacker.name + " \u2192 " + victim.name + " (" + rolled + " vs AC " + attempt.ac + (attempt.hit ? ", " + attempt.damage + " damage" : "") + ")";
  }

  function applySlayCreditAndBloodlust(context) {
    const slainBeforeRecovery = new Set(context.activeAtStart.filter((id) => playerById(id).hp <= 0));
    context.slainBeforeRecovery = Array.from(slainBeforeRecovery);
    context.slaysThisRound = {};
    context.bloodlust = [];

    const attackers = context.attackerIds.map(playerById);
    attackers.forEach((attacker) => {
      const credited = Array.from(new Set(context.hits.filter((hit) => {
        return hit.from === attacker.id && slainBeforeRecovery.has(hit.to);
      }).map((hit) => hit.to)));
      if (!credited.length) return;
      attacker.slays += credited.length;
      attacker.encounterSlays += credited.length;
      attacker.points += credited.length;
      attacker.encounterPoints += credited.length;
      context.slaysThisRound[attacker.id] = credited;
    });

    attackers.filter((player) => player.cls === "S").forEach((spellblade) => {
      const slainTargetsHit = Array.from(new Set(context.hits.filter((hit) => {
        return hit.from === spellblade.id && slainBeforeRecovery.has(hit.to);
      }).map((hit) => hit.to)));
      if (!slainTargetsHit.length) return;
      const healing = slainTargetsHit.length * (context.rawRolls[spellblade.id] === 20 ? 2 : 1);
      spellblade.hp = Math.max(0, spellblade.hp) + healing;
      spellblade.bloodlustActive = healing;
      context.bloodlust.push({ id: spellblade.id, healing: healing });
    });
  }

  function resolveAttackStep(options) {
    const settings = options || {};
    if (settings.auto) {
      randomTargetsAndBlessings();
      living().forEach((player) => { player.roll = rollD20(); });
    }
    const error = validateStep();
    if (error) {
      state.validationAttempted = true;
      $("#validation-message").textContent = "";
      renderArenaOnly();
      return false;
    }
    state.validationAttempted = false;
    beginRoundRecord();
    snapshot();
    state.players.forEach((player) => { player.bloodlustActive = 0; });
    state.visualSelector = null;
    const activeAtStart = living().map((p) => p.id);
    const bonuses = getBonuses();
    const rawRolls = {};
    const targetNames = {};
    const targetIds = {};
    state.players.forEach((p) => {
      if (p.hp > 0) {
        rawRolls[p.id] = p.roll;
        targetIds[p.id] = p.target;
        targetNames[p.id] = playerById(p.target).name;
      }
    });

    const fumbledOut = new Set();
    activeAtStart.forEach((id) => {
      const player = playerById(id);
      if (rawRolls[id] === 1) {
        player.hp -= 1;
        if (player.hp <= 0) fumbledOut.add(id);
      }
    });

    const attackers = activeAtStart.map(playerById).filter((p) => p.hp > 0 && rawRolls[p.id] !== 1);
    const attackable = activeAtStart.map(playerById).filter((p) => p.hp > 0);
    const preHp = {};
    state.players.forEach((p) => { preHp[p.id] = p.hp; });
    const hits = [];
    const attempts = [];

    attackers.forEach((attacker) => {
      const raw = rawRolls[attacker.id];
      const adjusted = raw + (bonuses.attack[attacker.id] || 0);
      const victims = attacker.cls === "W" ? attackable.filter((p) => p.id !== attacker.id) : attackable.filter((p) => p.id === attacker.target);
      victims.forEach((victim) => {
        const protectedAc = CLASS_DATA[victim.cls].ac + (bonuses.ac[victim.id] || 0);
        const successful = raw === 20 || adjusted >= protectedAc;
        let damage = 0;
        if (successful) {
          if (attacker.cls === "W") damage = victim.id === attacker.target ? 2 : 1;
          else if (attacker.cls === "S") damage = 2;
          else damage = preHp[attacker.id] === 1 ? 2 : 1;
          if (raw === 20) damage *= 2;
          hits.push({ from: attacker.id, to: victim.id, damage: damage });
        }
        attempts.push({ from: attacker.id, to: victim.id, raw: raw, adjusted: adjusted, ac: protectedAc, hit: successful, damage: damage });
      });
    });

    const damageByTarget = {};
    hits.forEach((hit) => { damageByTarget[hit.to] = (damageByTarget[hit.to] || 0) + hit.damage; });
    attackable.forEach((victim) => {
      victim.hp = Math.max(0, victim.hp - (damageByTarget[victim.id] || 0));
    });

    const rollText = activeAtStart.map((id) => {
      const boost = bonuses.attack[id] || 0;
      return playerById(id).name + " " + rawRolls[id] + (boost ? "+" + boost : "") + " \u2192 " + targetNames[id];
    }).join("; ");
    const logEntry = {
      kind: "attack",
      title: "E" + state.encounter + " \u00B7 Round " + state.step,
      rolls: rollText,
      successes: attempts.filter((item) => item.hit).map(attemptText),
      misses: attempts.filter((item) => !item.hit).map(attemptText),
      events: []
    };
    activeAtStart.forEach((id) => {
      if (rawRolls[id] === 1) logEntry.events.push(playerById(id).name + " fumbles and loses 1 HP" + (fumbledOut.has(id) ? ", becoming an Arena Spirit." : "."));
    });

    const context = {
      activeAtStart: activeAtStart,
      rawRolls: rawRolls,
      targetIds: targetIds,
      targetNames: targetNames,
      attackerIds: attackers.map((p) => p.id),
      hits: hits,
      attempts: attempts,
      preHp: preHp,
      fumbledOut: Array.from(fumbledOut),
      cycles: [],
      rollOffs: [],
      cycleIndex: 0,
      contenders: [],
      currentRolls: {},
      logEntry: logEntry
    };
    applySlayCreditAndBloodlust(context);
    context.cycles = selectFinalEncounterRollOffCycles(context);
    context.contenders = context.cycles[0] ? context.cycles[0].slice() : [];

    if (context.cycles.length && settings.autoComplete) {
      context.cycles.forEach((cycle) => {
        const result = runAutomaticRollOff(cycle);
        cycle.forEach((id) => { playerById(id).hp = id === result.winner ? Math.max(1, playerById(id).hp) : 0; });
        context.rollOffs.push(result);
      });
      finalizeAttackResolution(context);
    } else if (context.cycles.length) {
      state.pendingResolution = context;
      state.phase = "rolloff";
      render();
    } else {
      finalizeAttackResolution(context);
    }
    return true;
  }

  function rollRollOffAll() {
    const context = state.pendingResolution;
    if (!context) return;
    context.contenders.forEach((id) => { context.currentRolls[id] = rollD20(); });
    renderRollOff();
  }

  function resolveRollOffRound() {
    const context = state.pendingResolution;
    if (!context) return;
    const results = context.contenders.map((id) => ({ id: id, roll: Number(context.currentRolls[id]) }));
    if (results.some((item) => !Number.isInteger(item.roll) || item.roll < 1 || item.roll > 20)) {
      $("#rolloff-message").textContent = "Enter or roll a d20 result for every contender.";
      return;
    }
    const high = Math.max.apply(null, results.map((item) => item.roll));
    const leaders = results.filter((item) => item.roll === high).map((item) => item.id);
    const currentCycle = context.cycles[context.cycleIndex];
    let record = context.rollOffs[context.cycleIndex];
    if (!record) {
      record = { cycle: currentCycle.slice(), winner: null, rounds: [] };
      context.rollOffs[context.cycleIndex] = record;
    }
    record.rounds.push(results);
    if (leaders.length > 1) {
      context.contenders = leaders;
      context.currentRolls = {};
      render();
      return;
    }
    record.winner = leaders[0];
    currentCycle.forEach((id) => { playerById(id).hp = id === record.winner ? Math.max(1, playerById(id).hp) : 0; });
    context.cycleIndex += 1;
    if (context.cycleIndex < context.cycles.length) {
      context.contenders = context.cycles[context.cycleIndex].slice();
      context.currentRolls = {};
      render();
    } else {
      state.phase = "play";
      finalizeAttackResolution(context);
    }
  }

  function finalizeAttackResolution(context) {
    const fumbledOut = new Set(context.fumbledOut);
    const finalDead = new Set(context.activeAtStart.filter((id) => playerById(id).hp <= 0));

    Object.keys(context.slaysThisRound).forEach((id) => {
      const names = context.slaysThisRound[id].map((victimId) => playerById(victimId).name).join(", ");
      context.logEntry.events.push(playerById(id).name + " earns " + context.slaysThisRound[id].length + " slay point" + (context.slaysThisRound[id].length === 1 ? "" : "s") + " for damaging " + names + " before they were slain.");
    });
    context.bloodlust.forEach((item) => context.logEntry.events.push(playerById(item.id).name + " regains " + item.healing + " HP through Bloodlust."));
    context.rollOffs.forEach((item) => {
      const members = item.cycle.map((id) => playerById(id).name).join(", ");
      const rolls = item.rounds.map((round) => round.map((entry) => playerById(entry.id).name + " " + entry.roll).join(", ")).join("; reroll: ");
      context.logEntry.events.push("Final Survivor Roll-Off: " + members + ". " + rolls + ". " + playerById(item.winner).name + " survives at 1 HP.");
    });
    const newlyDead = Array.from(finalDead).filter((id) => !fumbledOut.has(id));
    if (newlyDead.length) context.logEntry.events.push(newlyDead.map((id) => playerById(id).name).join(", ") + " " + (newlyDead.length === 1 ? "is" : "are") + " slain and become Arena Spirits.");
    state.logs.unshift(context.logEntry);
    recordRound(context.logEntry);

    state.players.forEach((p) => {
      p.target = null;
      p.roll = null;
      p.spiritTarget = null;
      p.blessing = "might";
    });
    state.pendingResolution = null;
    state.visualSelector = null;
    state.validationAttempted = false;
    state.step += 1;
    const survivors = living();
    if (survivors.length <= 1) finishEncounter(survivors);
    render();
  }

  function finishEncounter(survivors) {
    if (survivors.length === 1) {
      const winner = survivors[0];
      winner.points += 3;
      winner.encounterPoints += 3;
      winner.survivals += 1;
      state.logs.unshift(winner.name + " is the sole survivor and earns 3 points.");
    } else {
      state.logs.unshift("The arena is empty. No survival points are awarded.");
    }
    state.encounterHistory.push({
      encounter: state.encounter,
      winnerId: survivors.length === 1 ? survivors[0].id : null,
      scores: state.players.map((p) => ({ id: p.id, points: p.encounterPoints, cls: p.cls }))
    });
    state.phase = state.encounter >= state.encounterCount ? "complete" : "between";
    const gauntlet = activeGauntlet();
    if (gauntlet) {
      const encounter = gauntlet.encounters.find((item) => item.number === state.encounter);
      if (encounter) {
        encounter.status = "Complete";
        encounter.winnerId = survivors.length === 1 ? survivors[0].id : null;
      }
      if (state.phase === "complete") {
        gauntlet.status = "Complete";
        const leaders = championshipLeaders();
        gauntlet.championId = leaders.length === 1 ? leaders[0].id : null;
        gauntlet.unbrokenIds = state.players.filter((player) => player.survivals === state.encounterCount).map((player) => player.id);
      }
      persistChronicle();
    }
  }

  function simulateRest() {
    if (state.phase !== "play") return;
    let guard = 0;
    while (state.phase === "play" && guard < 100) {
      resolveAttackStep({ auto: true, autoComplete: true });
      guard += 1;
    }
    if (guard >= 100 && state.phase === "play") {
      state.logs.unshift("Simulation paused after 100 rounds.");
      render();
    }
  }

  function beginNextEncounter() {
    if (state.phase !== "between") return;
    snapshot();
    state.encounter += 1;
    state.step = 1;
    state.phase = "play";
    state.validationAttempted = false;
    state.players.forEach((player) => {
      const select = root.querySelector('[data-next-class="' + player.id + '"]');
      if (select) player.cls = select.value;
      player.classHistory.push(player.cls);
      player.hp = CLASS_DATA[player.cls].hp;
      player.target = null;
      player.roll = null;
      player.spiritTarget = null;
      player.blessing = "might";
      player.encounterPoints = 0;
      player.encounterSlays = 0;
      player.bloodlustActive = 0;
    });
    state.logs.unshift("Encounter " + state.encounter + " begins. All characters return to starting HP.");
    render();
  }

  function adjustHp(id, amount) {
    const player = playerById(id);
    if (!player || state.phase !== "play") return;
    snapshot();
    player.hp += amount;
    if (player.hp < 0) player.hp = 0;
    if (player.cls !== "S" && player.hp > CLASS_DATA[player.cls].hp) player.hp = CLASS_DATA[player.cls].hp;
    player.target = null;
    player.roll = null;
    state.logs.unshift(player.name + " HP adjusted to " + player.hp + ".");
    if (living().length <= 1) finishEncounter(living());
    render();
  }

  function championshipLeaders() {
    const ordered = state.players.slice().sort((a, b) => b.points - a.points || b.survivals - a.survivals || b.slays - a.slays || a.id - b.id);
    if (!ordered.length) return [];
    const best = ordered[0];
    return ordered.filter((p) => p.points === best.points && p.survivals === best.survivals && p.slays === best.slays);
  }

  function rollChampionshipTiebreak() {
    let contenders = championshipLeaders();
    if (contenders.length <= 1) return;
    const rounds = [];
    while (contenders.length > 1) {
      const results = contenders.map((p) => ({ player: p, roll: rollD20() }));
      rounds.push(results);
      const high = Math.max.apply(null, results.map((item) => item.roll));
      contenders = results.filter((item) => item.roll === high).map((item) => item.player);
    }
    state.championshipWinner = contenders[0].id;
    const text = rounds.map((round) => round.map((item) => item.player.name + " " + item.roll).join(", ")).join("; reroll: ");
    state.logs.unshift("Championship Roll-Off: " + text + ". " + contenders[0].name + " wins the Gauntlet.");
    const gauntlet = activeGauntlet();
    if (gauntlet) {
      gauntlet.championId = contenders[0].id;
      persistChronicle();
    }
    render();
  }

  function startOver() {
    const gauntlet = activeGauntlet();
    if (gauntlet && gauntlet.status === "In progress") {
      gauntlet.status = "Reset";
      persistChronicle();
    }
    state.phase = "setup";
    $("#game-view").classList.add("hidden");
    $("#setup-view").classList.remove("hidden");
    setupRows();
  }

  function renderArenaOnly() {
    const activeTargets = new Set(living().map((p) => p.target).filter(Boolean));
    const bonuses = getBonuses();
    const rollOffIds = new Set(state.pendingResolution ? state.pendingResolution.cycles.slice(state.pendingResolution.cycleIndex).flat() : []);
    const drawnMutual = new Set();
    $("#target-line-marks").innerHTML = living().map((player) => {
      const target = playerById(player.target);
      if (!target || target.hp <= 0) return "";
      const start = seatPosition(player.id);
      const end = seatPosition(target.id);
      const playerColor = CLASS_COLORS[player.cls];
      const targetColor = CLASS_COLORS[target.cls];
      const markerId = "attack-arrow-" + player.id;
      const fullDx = end.x - start.x;
      const fullDy = end.y - start.y;
      const fullLength = Math.sqrt(fullDx * fullDx + fullDy * fullDy) || 1;
      const clearance = Math.min(7.2, fullLength * 0.23);
      const x1 = start.x + (fullDx / fullLength) * clearance;
      const y1 = start.y + (fullDy / fullLength) * clearance;
      const x2 = end.x - (fullDx / fullLength) * clearance;
      const y2 = end.y - (fullDy / fullLength) * clearance;
      const mutual = target.target === player.id;
      if (mutual) {
        const pairKey = [player.id, target.id].sort().join("-");
        if (drawnMutual.has(pairKey)) return "";
        drawnMutual.add(pairKey);
        const gradientId = "mutual-gradient-" + pairKey;
        const markerA = "mutual-a-" + pairKey;
        const markerB = "mutual-b-" + pairKey;
        const dx = x2 - x1;
        const dy = y2 - y1;
        const length = Math.sqrt(dx * dx + dy * dy) || 1;
        const bendX = (x1 + x2) / 2 + (-dy / length) * 7;
        const bendY = (y1 + y2) / 2 + (dx / length) * 7;
        return '<defs><linearGradient id="' + gradientId + '" gradientUnits="userSpaceOnUse" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"><stop offset="0%" style="stop-color:' + targetColor + '"></stop><stop offset="46%" style="stop-color:' + targetColor + '"></stop><stop offset="54%" style="stop-color:' + playerColor + '"></stop><stop offset="100%" style="stop-color:' + playerColor + '"></stop></linearGradient><marker id="' + markerA + '" markerUnits="userSpaceOnUse" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="5" markerHeight="5" orient="auto-start-reverse"><path d="M0 0 L10 5 L0 10 Z" style="fill:' + targetColor + '"></path></marker><marker id="' + markerB + '" markerUnits="userSpaceOnUse" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="5" markerHeight="5" orient="auto-start-reverse"><path d="M0 0 L10 5 L0 10 Z" style="fill:' + playerColor + '"></path></marker></defs><path class="mutual-target" d="M ' + x1 + ' ' + y1 + ' Q ' + bendX + ' ' + bendY + ' ' + x2 + ' ' + y2 + '" stroke="url(#' + gradientId + ')" marker-start="url(#' + markerA + ')" marker-end="url(#' + markerB + ')"></path>';
      }
      const dx = x2 - x1;
      const dy = y2 - y1;
      const length = Math.sqrt(dx * dx + dy * dy) || 1;
      const bendX = (x1 + x2) / 2 + (-dy / length) * 2.5;
      const bendY = (y1 + y2) / 2 + (dx / length) * 2.5;
      return '<defs><marker id="' + markerId + '" markerUnits="userSpaceOnUse" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="4.4" markerHeight="4.4" orient="auto"><path d="M0 0 L10 5 L0 10 Z" style="fill:' + playerColor + '"></path></marker></defs><path d="M ' + x1 + ' ' + y1 + ' Q ' + bendX + ' ' + bendY + ' ' + x2 + ' ' + y2 + '" style="stroke:' + playerColor + '" marker-end="url(#' + markerId + ')"></path>';
    }).join("");
    $("#spirit-line-marks").innerHTML = spirits().filter((spirit) => !rollOffIds.has(spirit.id)).map((spirit) => {
      const target = playerById(spirit.spiritTarget);
      if (!target || target.hp <= 0) return "";
      const start = seatPosition(spirit.id);
      const end = seatPosition(target.id);
      const bendX = 50 + (start.y - end.y) * 0.12;
      const bendY = 50 + (end.x - start.x) * 0.12;
      const x1 = start.x + (end.x - start.x) * 0.16;
      const y1 = start.y + (end.y - start.y) * 0.16;
      const x2 = start.x + (end.x - start.x) * 0.78;
      const y2 = start.y + (end.y - start.y) * 0.78;
      return '<path d="M ' + x1 + ' ' + y1 + ' Q ' + bendX + ' ' + bendY + ' ' + x2 + ' ' + y2 + '" marker-end="url(#giant-d20-spirit-mark)"></path>';
    }).join("");
    $("#arena-seats").innerHTML = state.players.map((player) => {
      const pos = seatPosition(player.id);
      const isSpirit = player.hp <= 0 && !rollOffIds.has(player.id);
      const css = isSpirit ? "spirit" : CLASS_DATA[player.cls].css;
      const attackBoost = bonuses.attack[player.id] || 0;
      const acBoost = bonuses.ac[player.id] || 0;
      const boostText = (attackBoost ? " \u00B7 +" + attackBoost + " attack" : "") + (acBoost ? " \u00B7 +" + acBoost + " AC" : "");
      const meta = isSpirit ? "Arena Spirit" : CLASS_DATA[player.cls].name + " \u00B7 " + player.hp + " HP \u00B7 AC " + CLASS_DATA[player.cls].ac + boostText;
      const baseHp = CLASS_DATA[player.cls].hp;
      const hpWidth = Math.max(0, Math.min(100, player.hp / baseHp * 100));
      const stars = player.survivals ? "\u2605".repeat(player.survivals) : "\u2606";
      const conditions = [];
      if (!isSpirit && player.cls === "F" && player.hp === 1) conditions.push('<span class="condition-badge">Last Stand</span>');
      if (!isSpirit && player.bloodlustActive) conditions.push('<span class="condition-badge bloodlust">Bloodlust +' + player.bloodlustActive + '</span>');
      if (rollOffIds.has(player.id)) conditions.push('<span class="condition-badge">Roll-Off</span>');
      const selected = state.visualSelector && state.visualSelector.id === player.id;
      return '<div class="seat ' + css + (activeTargets.has(player.id) ? " is-targeted" : "") + (selected ? " is-selecting" : "") + '" style="left:' + pos.x + '%;top:' + pos.y + '%"><button type="button" class="seat-marker" data-seat-player="' + player.id + '" aria-label="Select ' + esc(player.name) + '">' + iconMarkup(isSpirit ? "spirit" : player.cls) + '</button><div class="seat-name text-small">P' + player.id + ' \u00B7 ' + esc(player.name) + '</div><div class="seat-meta text-small"><span class="detail">' + esc(meta) + '</span></div>' + (isSpirit ? "" : '<div class="hp-bar" role="meter" aria-label="' + esc(player.name) + ' health: ' + player.hp + ' HP" aria-valuemin="0" aria-valuemax="' + Math.max(baseHp, player.hp) + '" aria-valuenow="' + player.hp + '"><span class="hp-fill" style="width:' + hpWidth + '%"></span><span class="hp-bar-label text-small">' + player.hp + ' HP</span></div>') + '<div class="seat-stats text-small"><span class="stat-label">Pts </span>' + player.points + ' \u00B7 <span class="stat-label">Slays </span>' + player.slays + ' (+' + player.encounterSlays + ') \u00B7 <span aria-label="' + player.survivals + ' survivals">' + stars + '</span></div><div class="seat-status text-small">' + conditions.join(" ") + '</div></div>';
    }).join("");
    $("#arena-rolls").innerHTML = state.players.map((player) => {
      if (player.hp <= 0 || state.phase !== "play") return "";
      const pos = seatPosition(player.id);
      return '<div class="roll-visual-control" style="left:' + pos.rx + '%;top:' + pos.ry + '%"><label class="sr-only" for="arena-roll-' + player.id + '">' + esc(player.name) + ' manual roll</label><select id="arena-roll-' + player.id + '" class="form-select" data-arena-roll="' + player.id + '">' + rollOptions(player.roll) + '</select></div>';
    }).join("");
    const blessingPopover = $("#spirit-blessing-popover");
    const blessingSelection = state.visualSelector && state.visualSelector.type === "spirit-blessing" ? state.visualSelector : null;
    if (blessingSelection) {
      const spirit = playerById(blessingSelection.id);
      const recipient = playerById(blessingSelection.targetId);
      if (spirit && recipient && spirit.hp <= 0 && recipient.hp > 0) {
        const pos = seatPosition(recipient.id);
        blessingPopover.style.left = Math.max(20, Math.min(80, pos.x)) + "%";
        blessingPopover.style.top = pos.y + "%";
        blessingPopover.dataset.placement = pos.y < 36 ? "below" : "above";
        blessingPopover.innerHTML = '<label class="text-small" for="arena-spirit-blessing-' + spirit.id + '"><strong>' + esc(spirit.name) + '</strong> blesses ' + esc(recipient.name) + '</label><select id="arena-spirit-blessing-' + spirit.id + '" class="form-select" data-arena-spirit-blessing="' + spirit.id + '"><option value="might"' + (spirit.blessing === "might" ? " selected" : "") + '>+1 attack</option><option value="protection"' + (spirit.blessing === "protection" ? " selected" : "") + '>+1 AC</option></select><button type="button" class="btn btn-ghost text-small" data-close-spirit-blessing>Done</button>';
        blessingPopover.classList.remove("hidden");
      } else {
        blessingPopover.classList.add("hidden");
        blessingPopover.innerHTML = "";
      }
    } else {
      blessingPopover.classList.add("hidden");
      blessingPopover.innerHTML = "";
    }
    const active = living();
    const summary = active.map((p) => p.name + " at " + p.hp + " HP" + (p.roll ? ", rolled " + p.roll : "")).join("; ");
    $("#arena-stage").setAttribute("aria-label", "Octagonal rolling tray. " + summary + ". " + spirits().length + " Arena Spirits.");
    updateValidationWarnings();
    refreshIcons();
  }

  function renderActionRows() {
    const active = living();
    const bonuses = getBonuses();
    $("#action-rows").innerHTML = active.map((player) => {
      const targets = active.filter((other) => other.id !== player.id).map((other) => '<option value="' + other.id + '"' + (player.target === other.id ? " selected" : "") + '>P' + other.id + ' \u00B7 ' + esc(other.name) + '</option>').join("");
      const acBoost = bonuses.ac[player.id] || 0;
      const attackBoost = bonuses.attack[player.id] || 0;
      const acLabel = CLASS_DATA[player.cls].ac + (acBoost ? " +" + acBoost : "");
      const rollBoost = attackBoost ? '<span class="text-muted">+' + attackBoost + '</span>' : "";
      const condition = player.cls === "F" && player.hp === 1 ? ' \u00B7 Last Stand' : (player.bloodlustActive ? ' \u00B7 Bloodlust +' + player.bloodlustActive : "");
      return '<tr><td><span class="player-line">' + classIdentity(player, false) + '<span><strong>' + esc(player.name) + '</strong><br><span class="text-muted text-small">P' + player.id + " \u00B7 " + CLASS_DATA[player.cls].name + condition + '</span></span></span></td><td><span class="hp-control"><button type="button" class="btn btn-ghost" data-hp-minus="' + player.id + '" aria-label="Reduce ' + esc(player.name) + ' HP">\u2212</button><span class="hp-value">' + player.hp + '</span><button type="button" class="btn btn-ghost" data-hp-plus="' + player.id + '" aria-label="Increase ' + esc(player.name) + ' HP">+</button><span class="text-muted">/ AC ' + acLabel + '</span></span></td><td><label class="sr-only" for="target-' + player.id + '">' + esc(player.name) + ' target</label><select id="target-' + player.id + '" class="form-select" data-target-player="' + player.id + '"><option value="">Choose target</option>' + targets + '</select></td><td><span class="roll-field"><label class="sr-only" for="roll-' + player.id + '">' + esc(player.name) + ' roll</label><select id="roll-' + player.id + '" class="form-select" data-roll-player="' + player.id + '">' + rollOptions(player.roll) + '</select>' + rollBoost + '<button type="button" class="btn" data-roll-one="' + player.id + '">Roll</button></span></td></tr>';
    }).join("");
  }

  function renderSpirits() {
    const ghostPlayers = spirits();
    const active = living();
    $("#spirit-controls").classList.toggle("hidden", !ghostPlayers.length || state.phase !== "play");
    $("#spirit-rows").innerHTML = ghostPlayers.map((spirit) => {
      const recipients = active.map((player) => '<option value="' + player.id + '"' + (spirit.spiritTarget === player.id ? " selected" : "") + '>P' + player.id + ' \u00B7 ' + esc(player.name) + '</option>').join("");
      return '<tr><td><span class="player-line">' + classIdentity(spirit, false) + '<span>' + esc(spirit.name) + '</span></span></td><td><label class="sr-only" for="spirit-target-' + spirit.id + '">' + esc(spirit.name) + ' blessing recipient</label><select id="spirit-target-' + spirit.id + '" class="form-select" data-spirit-target="' + spirit.id + '"><option value="">Choose player</option>' + recipients + '</select></td><td><label class="sr-only" for="spirit-blessing-' + spirit.id + '">' + esc(spirit.name) + ' blessing</label><select id="spirit-blessing-' + spirit.id + '" class="form-select" data-spirit-blessing="' + spirit.id + '"><option value="might"' + (spirit.blessing === "might" ? " selected" : "") + '>+1 attack</option><option value="protection"' + (spirit.blessing === "protection" ? " selected" : "") + '>+1 AC</option></select></td></tr>';
    }).join("");
  }

  function renderStandings() {
    const ranked = state.players.slice().sort((a, b) => b.points - a.points || b.survivals - a.survivals || b.slays - a.slays || a.id - b.id);
    $("#standings-head").innerHTML = '<th>Player</th>' + Array.from({ length: state.encounterCount }, (_, index) => '<th class="text-end">E' + (index + 1) + '</th>').join("") + '<th class="text-end">Slays</th><th class="text-end">Survivals</th><th class="text-end">Total</th>';
    $("#standings-rows").innerHTML = ranked.map((player, index) => {
      const champion = state.championshipWinner === player.id ? " \u00B7 Champion" : "";
      const encounterCells = Array.from({ length: state.encounterCount }, (_, index) => index + 1).map((encounterNumber) => {
        const completed = state.encounterHistory.find((item) => item.encounter === encounterNumber);
        if (completed) {
          const score = completed.scores.find((item) => item.id === player.id);
          return '<td class="text-end">' + score.points + (completed.winnerId === player.id ? " \u2605" : "") + '</td>';
        }
        if (state.phase === "play" && state.encounter === encounterNumber) return '<td class="text-end">' + player.encounterPoints + '</td>';
        return '<td class="text-end text-muted">\u2013</td>';
      }).join("");
      const identity = '<span class="class-icon ' + CLASS_DATA[player.cls].css + '">' + iconMarkup(player.cls) + '</span>';
      const survivalStars = player.survivals ? "\u2605".repeat(player.survivals) : "\u2013";
      return '<tr><td class="standings-name"><span class="player-line">' + identity + '<span>' + (state.phase === "complete" ? (index + 1) + ". " : "") + esc(player.name) + '<span class="text-muted">' + champion + '</span><br><span class="text-muted text-small">P' + player.id + " \u00B7 " + CLASS_DATA[player.cls].name + '</span></span></span></td>' + encounterCells + '<td class="text-end">' + player.slays + '</td><td class="text-end" aria-label="' + player.survivals + ' survivals">' + survivalStars + '</td><td class="text-end"><strong>' + player.points + '</strong></td></tr>';
    }).join("");
  }

  function renderBetween() {
    const between = state.phase === "between" || state.phase === "complete";
    $("#between-view").classList.toggle("hidden", !between);
    $("#play-controls").classList.toggle("hidden", state.phase !== "play");
    if (!between) return;
    const latest = state.encounterHistory[state.encounterHistory.length - 1];
    const winner = latest && latest.winnerId ? playerById(latest.winnerId) : null;
    if (state.phase === "complete") {
      const leaders = championshipLeaders();
      const champion = state.championshipWinner ? playerById(state.championshipWinner) : (leaders.length === 1 ? leaders[0] : null);
      $("#between-heading").textContent = "Gauntlet complete";
      const championTitle = champion && champion.survivals === state.encounterCount ? "The Unbroken Gauntlet Champion" : "The Gauntlet Champion";
      $("#match-summary").innerHTML = champion ? '<strong>' + esc(champion.name) + '</strong> is <strong>' + championTitle + '</strong> with ' + champion.points + ' points.' : 'The Gauntlet is tied between <strong>' + leaders.map((p) => esc(p.name)).join(" and ") + '</strong> after all listed tiebreakers.';
      $("#class-change-area").classList.add("hidden");
      $("#series-complete-actions").classList.remove("hidden");
      $("#championship-rolloff").classList.toggle("hidden", leaders.length <= 1 || Boolean(state.championshipWinner));
    } else {
      $("#between-heading").textContent = "Encounter " + state.encounter + " complete";
      $("#match-summary").innerHTML = winner ? '<strong>' + esc(winner.name) + '</strong> was the sole survivor.' : 'The Encounter ended in a complete wipe.';
      $("#class-change-area").classList.remove("hidden");
      $("#series-complete-actions").classList.add("hidden");
      $("#next-class-rows").innerHTML = state.players.map((player) => '<tr><td>' + esc(player.name) + '</td><td><label class="sr-only" for="next-class-' + player.id + '">' + esc(player.name) + ' next class</label><select id="next-class-' + player.id + '" class="form-select class-picker" data-next-class="' + player.id + '">' + classOptions(player.cls) + '</select></td></tr>').join("");
    }
  }

  function renderLog() {
    $("#event-log").innerHTML = state.logs.slice(0, 40).map(normalizeLogTerminology).map((entry) => {
      if (!entry || typeof entry === "string") return "<li>" + esc(entry || "") + "</li>";
      const successes = entry.successes.length ? entry.successes.map(esc).join("; ") : "None";
      const misses = entry.misses.length ? entry.misses.map(esc).join("; ") : "None";
      const events = entry.events.length ? '<div>' + entry.events.map(esc).join(" ") + '</div>' : "";
      return '<li class="log-step"><strong>' + esc(entry.title) + '</strong><div class="text-muted">Rolls: ' + esc(entry.rolls) + '</div><div class="log-success">Successful: ' + successes + '</div><div class="log-miss">Below AC: ' + misses + '</div>' + events + '</li>';
    }).join("");
  }

  function renderChronicle() {
    const records = state.chronicle || [];
    if (!records.length) {
      $("#chronicle-list").innerHTML = '<div class="text-muted">Resolved rounds will appear here.</div>';
      return;
    }
    $("#chronicle-list").innerHTML = records.map((gauntlet) => {
      const date = new Date(gauntlet.startedAt).toLocaleString();
      const branch = gauntlet.branchLabel ? " \u00B7 " + esc(gauntlet.branchLabel) : "";
      const encounterMarkup = (gauntlet.encounters || []).map((encounter) => {
        const rounds = (encounter.rounds || []).map((round) => {
          const log = round.log || { successes: [], misses: [], events: [], rolls: "" };
          const successes = (log.successes || []).length ? log.successes.map(esc).join("; ") : "None";
          const misses = (log.misses || []).length ? log.misses.map(esc).join("; ") : "None";
          const events = (log.events || []).map(esc).join(" ");
          return '<div class="chronicle-round"><details><summary>Round ' + round.number + '</summary><div class="chronicle-log"><div>Rolls: ' + esc(log.rolls || "") + '</div><div class="log-success">Successful: ' + successes + '</div><div class="log-miss">Below AC: ' + misses + '</div><div>' + events + '</div></div></details><button type="button" class="btn btn-ghost" data-load-round="' + esc(gauntlet.id) + '" data-load-encounter="' + encounter.number + '" data-load-round-number="' + round.number + '">Load from round start</button></div>';
        }).join("");
        return '<details><summary>Encounter ' + encounter.number + ' \u00B7 ' + esc(encounter.status || "In progress") + '</summary>' + rounds + '</details>';
      }).join("");
      return '<details' + (gauntlet.id === state.gauntletId ? " open" : "") + '><summary>' + date + ' \u00B7 ' + esc(gauntlet.status || "In progress") + branch + '</summary>' + encounterMarkup + '</details>';
    }).join("");
  }

  function loadRoundStart(gauntletId, encounterNumber, roundNumber) {
    const sourceGauntlet = state.chronicle.find((item) => item.id === gauntletId);
    const sourceEncounter = sourceGauntlet && sourceGauntlet.encounters.find((item) => item.number === Number(encounterNumber));
    const sourceRound = sourceEncounter && sourceEncounter.rounds.find((item) => item.number === Number(roundNumber));
    if (!sourceRound || !sourceRound.startState) return;
    const chronicle = state.chronicle;
    const restored = clone(sourceRound.startState);
    restored.encounterCount = restored.encounterCount || sourceGauntlet.encounterCount || 5;
    restored.chronicle = chronicle;
    restored.gauntletId = uid();
    restored.branchLabel = "Replay of Encounter " + encounterNumber + ", Round " + roundNumber;
    restored.roundStart = null;
    restored.snapshots = [];
    restored.pendingResolution = null;
    restored.visualSelector = null;
    restored.validationAttempted = false;
    state = restored;
    ensureGauntletRecord(state.players.map((player) => player.name));
    $("#setup-view").classList.add("hidden");
    $("#game-view").classList.remove("hidden");
    render();
  }

  function renderRollOff() {
    const context = state.pendingResolution;
    $("#rolloff-controls").classList.toggle("hidden", !context || state.phase !== "rolloff");
    if (!context || state.phase !== "rolloff") return;
    const cycle = context.cycles[context.cycleIndex];
    const roundNumber = (context.rollOffs[context.cycleIndex] ? context.rollOffs[context.cycleIndex].rounds.length : 0) + 1;
    $("#rolloff-summary").textContent = "Resolution " + (context.cycleIndex + 1) + " of " + context.cycles.length + " \u00B7 Round " + roundNumber + " \u00B7 Highest unique roll survives at 1 HP.";
    $("#rolloff-rows").innerHTML = context.contenders.map((id) => {
      const player = playerById(id);
      const identity = '<span class="player-line"><span class="class-icon ' + CLASS_DATA[player.cls].css + '">' + iconMarkup(player.cls) + '</span><span>P' + player.id + ' \u00B7 ' + esc(player.name) + '</span></span>';
      const value = context.currentRolls[id] === undefined ? "" : context.currentRolls[id];
      return '<div class="rolloff-row">' + identity + '<label class="sr-only" for="rolloff-' + id + '">' + esc(player.name) + ' Final Survivor Roll-Off result</label><select id="rolloff-' + id + '" class="form-select" data-rolloff-player="' + id + '">' + rollOptions(value) + '</select><button type="button" class="btn" data-rolloff-one="' + id + '">Roll</button></div>';
    }).join("");
    $("#rolloff-message").textContent = "";
  }

  function render() {
    if (state.phase === "setup") return;
    const active = living();
    const rollOffIds = new Set(state.pendingResolution ? state.pendingResolution.cycles.slice(state.pendingResolution.cycleIndex).flat() : []);
    const spiritCount = spirits().filter((player) => !rollOffIds.has(player.id)).length;
    $("#match-badge").textContent = "Encounter " + state.encounter + " of " + state.encounterCount;
    $("#step-badge").textContent = state.phase === "play" ? "Round " + state.step : (state.phase === "rolloff" ? "Final Survivor Roll-Off" : (state.phase === "complete" ? "Gauntlet complete" : "Encounter complete"));
    $("#alive-badge").textContent = (state.phase === "rolloff" ? active.length + rollOffIds.size : active.length) + " active \u00B7 " + spiritCount + " spirits";
    if (state.phase === "rolloff") {
      $("#centre-label").textContent = "Final Survivor Roll-Off";
      $("#centre-sub").textContent = "A final-Encounter target chain";
    } else if (state.phase === "play" && state.visualSelector) {
      const selector = playerById(state.visualSelector.id);
      $("#centre-label").textContent = state.visualSelector.type === "spirit" ? "Choose blessing target" : (state.visualSelector.type === "spirit-blessing" ? "Choose blessing" : "Choose attack target");
      $("#centre-sub").textContent = selector ? selector.name + " is selected" : "Click a player";
    } else {
      $("#centre-label").textContent = state.phase === "play" ? (active.some((p) => p.roll === null) ? "Choose targets" : "Ready to resolve") : "Encounter complete";
      $("#centre-sub").textContent = state.phase === "play" ? "Click a player, then their target" : "Review the standings";
    }
    $("#undo-step").disabled = !state.snapshots.length;
    $("#arena-resolve-step").classList.toggle("hidden", state.phase !== "play");
    $("#random-targets").textContent = spirits().length ? "Random targets + spirits" : "Random targets";
    $("#validation-message").textContent = "";
    renderArenaOnly();
    renderActionRows();
    renderSpirits();
    renderStandings();
    renderBetween();
    renderRollOff();
    renderLog();
    renderChronicle();
    refreshIcons();
  }

  function handleArenaSeatClick(id) {
    if (state.phase !== "play") return;
    const clicked = playerById(id);
    if (!clicked) return;
    if (!state.visualSelector) {
      state.visualSelector = { type: clicked.hp <= 0 ? "spirit" : "attack", id: clicked.id };
      render();
      return;
    }
    const source = playerById(state.visualSelector.id);
    if (!source || source.id === clicked.id) {
      state.visualSelector = null;
      render();
      return;
    }
    if (clicked.hp <= 0) {
      state.visualSelector = { type: "spirit", id: clicked.id };
      render();
      return;
    }
    if (state.visualSelector.type === "spirit" && source.hp <= 0) {
      source.spiritTarget = clicked.id;
      state.visualSelector = { type: "spirit-blessing", id: source.id, targetId: clicked.id };
    } else if (source.hp > 0) {
      source.target = clicked.id;
      state.visualSelector = null;
    }
    render();
  }

  $("#player-count").addEventListener("change", setupRows);
  $("#begin-series").addEventListener("click", beginSeries);
  $("#roll-all").addEventListener("click", rollAll);
  $("#random-targets").addEventListener("click", function () { randomTargetsAndBlessings(); render(); });
  $("#strategic-targets").addEventListener("click", function () { bestStrategicTargets(); render(); });
  $("#simulate-step").addEventListener("click", function () { resolveAttackStep({ auto: true }); });
  $("#simulate-match").addEventListener("click", simulateRest);
  $("#resolve-step").addEventListener("click", function () { resolveAttackStep(); });
  $("#arena-resolve-step").addEventListener("click", function () { resolveAttackStep(); });
  $("#undo-step").addEventListener("click", undo);
  $("#next-match").addEventListener("click", beginNextEncounter);
  $("#championship-rolloff").addEventListener("click", rollChampionshipTiebreak);
  $("#new-series").addEventListener("click", startOver);
  $("#play-again").addEventListener("click", startOver);
  $("#roll-rolloff-all").addEventListener("click", rollRollOffAll);
  $("#resolve-rolloff").addEventListener("click", resolveRollOffRound);

  root.addEventListener("change", function (event) {
    const target = event.target;
    if (target.matches("[data-target-player]")) {
      playerById(target.dataset.targetPlayer).target = target.value ? Number(target.value) : null;
      renderArenaOnly();
    }
    if (target.matches("[data-roll-player]")) {
      const value = Number(target.value);
      playerById(target.dataset.rollPlayer).roll = target.value !== "" && Number.isInteger(value) ? value : null;
      renderArenaOnly();
    }
    if (target.matches("[data-arena-roll]")) {
      const value = Number(target.value);
      playerById(target.dataset.arenaRoll).roll = target.value !== "" && Number.isInteger(value) ? value : null;
      renderActionRows();
      updateValidationWarnings();
      refreshIcons();
    }
    if (target.matches("[data-spirit-target]")) {
      playerById(target.dataset.spiritTarget).spiritTarget = target.value ? Number(target.value) : null;
      render();
    }
    if (target.matches("[data-spirit-blessing]")) {
      playerById(target.dataset.spiritBlessing).blessing = target.value;
      render();
    }
    if (target.matches("[data-arena-spirit-blessing]")) {
      playerById(target.dataset.arenaSpiritBlessing).blessing = target.value;
      state.visualSelector = null;
      render();
    }
    if (target.matches("[data-rolloff-player]")) {
      const value = Number(target.value);
      state.pendingResolution.currentRolls[target.dataset.rolloffPlayer] = target.value !== "" && Number.isInteger(value) ? value : null;
    }
  });

  root.addEventListener("click", function (event) {
    const rollButton = event.target.closest("[data-roll-one]");
    const minus = event.target.closest("[data-hp-minus]");
    const plus = event.target.closest("[data-hp-plus]");
    const rollOffButton = event.target.closest("[data-rolloff-one]");
    const seatButton = event.target.closest("[data-seat-player]");
    const loadRoundButton = event.target.closest("[data-load-round]");
    const closeSpiritBlessing = event.target.closest("[data-close-spirit-blessing]");
    if (rollButton) {
      playerById(rollButton.dataset.rollOne).roll = rollD20();
      render();
    } else if (rollOffButton && state.pendingResolution) {
      state.pendingResolution.currentRolls[rollOffButton.dataset.rolloffOne] = rollD20();
      renderRollOff();
      refreshIcons();
    } else if (closeSpiritBlessing) {
      state.visualSelector = null;
      render();
    } else if (loadRoundButton) {
      loadRoundStart(loadRoundButton.dataset.loadRound, loadRoundButton.dataset.loadEncounter, loadRoundButton.dataset.loadRoundNumber);
    } else if (seatButton) {
      handleArenaSeatClick(seatButton.dataset.seatPlayer);
    } else if (minus) adjustHp(minus.dataset.hpMinus, -1);
    else if (plus) adjustHp(plus.dataset.hpPlus, 1);
  });

  setupRows();
}());
